var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    color: "white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69842 5.61903L8.12141 0.993487L8.12141 0.993486M3.69842 5.61903L8.26506 1.13085L8.12141 0.993486M3.69842 5.61903L1.87849 3.71668L1.87849 3.71667C1.63063 3.45762 1.22579 3.45911 0.979684 3.71976C0.739014 3.97465 0.740242 4.38259 0.982574 4.63594L0.982585 4.63595L3.25058 7.00663C3.4973 7.26452 3.89996 7.26444 4.1466 7.00651L9.01753 1.91251C9.25982 1.65912 9.26092 1.25114 9.02022 0.99632L9.0202 0.996302C8.77401 0.73573 8.3692 0.734349 8.12141 0.993486M3.69842 5.61903L8.12141 0.993486",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxIcon2);
export default __webpack_public_path__ + "static/media/checkbox-icon-2.ddad13d1f268fa074301281d4c750086.svg";
export { ForwardRef as ReactComponent };